const getFieldError = (field, value) => {
  const errorMap = {
    comment: value && value.trim() ? null : '* Required'
  };
  return errorMap[field] ?? null;
};

const getErrorInfo = (errorInfo, unvoidPickupData) => {
  const newErrorInfo = {};
  Object.keys(errorInfo).forEach((fieldName) => {
    newErrorInfo[fieldName] = getFieldError(fieldName, unvoidPickupData[fieldName]);
  });
  return newErrorInfo;
};

const getDefaultUnvoidPickData = () => ({
  comment: null,
  errorInfo: {
    comment: null
  }
});

export { getFieldError, getErrorInfo, getDefaultUnvoidPickData };
